import { Action } from 'redux';

const prefix = 'configurator/';
export const CONFIGURATOR_RESET = `${prefix}RESET`;
export const CONFIGURATOR_CHANGE_VALUE = `${prefix}CHANGE_VALUE`;
export const CONFIGURATOR_DELETE_VALUE = `${prefix}DELETE_VALUE`;
export const CONFIGURATOR_FIELD_BLUR = `${prefix}BLUR`;

export type ConfiguratorChangeValue = Action & {
  key: string;
  value: string;
};
export const onBlurField = () => ({
  type: CONFIGURATOR_FIELD_BLUR
});

export const onSelectValue = (key: string, value: string) => ({
  type: CONFIGURATOR_CHANGE_VALUE,
  key,
  value
});

export const onDeleteValue = (key: string) => ({
  type: CONFIGURATOR_DELETE_VALUE,
  key
});

export const configReset = () => ({
  type: CONFIGURATOR_RESET
});
